<template>
  <div class="forCon">
    <div class="tableName">表1 220/380V 单相及三相线路泄漏电流</div>
    <div class="table">
      <el-table :data="firdata" style="width: 100%">
        <el-table-column prop="firname" label="线缆截面/mm²"></el-table-column>
        <el-table-column prop="secname" label="不同绝缘材质的线缆泄露电流/(mA/km)">
          <el-table-column prop="jlyx" label="聚氯乙烯"></el-table-column>
          <el-table-column prop="xpjy" label="橡皮绝缘"></el-table-column>
          <el-table-column prop="jljyx" label="交联聚乙烯"></el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="tableName">表2 电动机泄漏电流</div>
    <div class="table">
      <div>
        <span class="firSp">电动机功率/kW</span>
        <span class="otherSp">1.5</span>
        <span class="otherSp">2.2</span>
        <span class="otherSp">5.5</span>
        <span class="otherSp">7.5</span>
        <span class="otherSp">11</span>
        <span class="otherSp">15</span>
        <span class="otherSp">18.5</span>
        <span class="otherSp">22</span>
        <span class="otherSp">30</span>
        <span class="otherSp">37</span>
        <span class="otherSp">45</span>
        <span class="otherSp">55</span>
        <span class="otherSp">75</span>
      </div>
      <div>
        <div class="firSp">正常运行时的泄漏电流/mA</div>
        <div class="otherSp">0.15</div>
        <div class="otherSp">0.18</div>
        <div class="otherSp">0.29</div>
        <div class="otherSp">0.38</div>
        <div class="otherSp">0.5</div>
        <div class="otherSp">0.57</div>
        <div class="otherSp">0.65</div>
        <div class="otherSp">0.72</div>
        <div class="otherSp">0.87</div>
        <div class="otherSp">1.0</div>
        <div class="otherSp">1.09</div>
        <div class="otherSp">1.22</div>
        <div class="otherSp">1.48</div>
      </div>
    </div>
    <div class="tableName">表3 荧光灯、家用电器及计算机泄漏电流</div>
    <div class="table">
      <el-table :data="secdata">
        <el-table-column prop="id" label="设备名称"></el-table-column>
        <el-table-column prop="name" label="型式"></el-table-column>
        <el-table-column prop="amount1" label="泄漏电流/mA"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      firdata:
        [
          {
            firname: "4",
            jlyx: "52",
            xpjy: "27",
            jljyx: "17",
          },
          {
            firname: "6",
            jlyx: "52",
            xpjy: "32",
            jljyx: "20",
          },
          {
            firname: "10",
            jlyx: "56",
            xpjy: "39",
            jljyx: "25",
          },
          {
            firname: "16",
            jlyx: "62",
            xpjy: "40",
            jljyx: "26",
          },
          {
            firname: "25",
            jlyx: "70",
            xpjy: "45",
            jljyx: "29",
          },
          {
            firname: "35",
            jlyx: "70",
            xpjy: "49",
            jljyx: "33",
          },
          {
            firname: "50",
            jlyx: "79",
            xpjy: "49",
            jljyx: "33",
          },
          {
            firname: "70",
            jlyx: "89",
            xpjy: "55",
            jljyx: "33",
          },
          {
            firname: "95",
            jlyx: "99",
            xpjy: "55",
            jljyx: "33",
          },
          {
            firname: "120",
            jlyx: "109",
            xpjy: "60",
            jljyx: "38",
          },
          {
            firname: "150",
            jlyx: "112",
            xpjy: "60",
            jljyx: "38",
          },
          {
            firname: "185",
            jlyx: "116",
            xpjy: "60",
            jljyx: "38",
          },
          {
            firname: "240",
            jlyx: "127",
            xpjy: "61",
            jljyx: "39",
          },
        ],
      secdata: [
        {
          id: '荧光灯',
          name: '安装在金属构件上',
          amount1: '0.1',
        }, {
          id: '荧光灯',
          name: '安装在木制或混凝土构件上',
          amount1: '0.02',

        }, {
          id: '家用电器',
          name: '手握式Ⅰ型设备',
          amount1: '≤0.75',

        }, {
          id: '家用电器',
          name: '固定式Ⅰ型设备',
          amount1: '≤3.5',

        }, {
          id: '家用电器',
          name: 'Ⅱ级设备',
          amount1: '≤0.25',

        }, {
          id: '家用电器',
          name: 'Ⅰ级电热设备',
          amount1: '≤0.75 ~ 5',

        }, {
          id: '计算机',
          name: '移动式',
          amount1: '1.0',

        }, {
          id: '计算机',
          name: '固定式',
          amount1: '3.5',

        }],
    }
  }
}
</script>

<style scoped lang="less">
.forCon {
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .table {
    width: 100%;
    min-width: 0;
    margin-top: 28px;
    border-left: 1px solid #EBEEF5;
    border-top: 1px solid #EBEEF5;
  }

  .tableName {
    font-size: 22px;
    color: #000000;
    text-align: center;
    height: 38px;
    line-height: 38px;
    margin-top: 28px;
  }

  .firSp {
    display: inline-block;
    vertical-align: middle;
    height: 40px;
    line-height: 40px;
    color: #252B3C;
    width: 22%;
    padding-left: 6px;
    border-right: 1px solid #ddd;
    font-weight: bold;
    border-bottom: 1px solid #ddd;

  }

  .otherSp {
    display: inline-block;
    vertical-align: middle;
    height: 40px;
    width: 6%;
    line-height: 40px;
    color: #7D879F;
    padding-left: 6px;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }
}
</style>
